package ui.console

import androidx.compose.runtime.*
import org.jetbrains.skiko.*
import provider.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.compose.navigation.viewmodel.*
import ui.*

class ConsoleScope private constructor(
    val mac: String,
    val nav: Navigation,
    val vm: ConsoleVM,
    val vmGlobal: GlobalVM,
    val account: CommonAccountProvider,
    val id: String,
    val action: (ConsoleVM.Action) -> Unit
) {

    companion object {
        @Composable
        fun remember(): ConsoleScope {
            val arg = LocalNavigationArgs.current.args(ConsoleArgs::class)
            val nav = LocalNavigation.current
            val vm = nav.viewModel(ConsoleVM::class, arg.mac)
            val vmGlobal = globalViewModel(GlobalVM::class)
            val account = LocalAccountProvider.current
            val action = ConsoleVM.Action.rememberAction(vm)
            return remember(arg.mac) {
                ConsoleScope(
                    mac = arg.mac,
                    nav = nav,
                    vm = vm,
                    vmGlobal = vmGlobal,
                    account = account,
                    action = action,
                    id = "${account.current?.id}-${currentNanoTime()}"
                ).apply {
                    vm.init(this)
                }
            }
        }
    }
}
